export default [
	{
		key: 'client',
		title: 'Client',
		scopedSlots: {customRender: 'client'},
	}, {
		key: 'contact',
		title: 'Contact',
		scopedSlots: {customRender: 'contact'},
	}, {
		key: 'ipAddress',
		title: 'IP Addresses',
		scopedSlots: {customRender: 'ipAddress'}
	}, {
		dataIndex: 'balance',
		key: 'balance',
		title: 'Balance',
		scopedSlots: {customRender: 'balance'}
	},
	// {
	// 	dataIndex: 'loan_balance',
	// 	key: 'loanBalance',
	// 	title: 'Loan',
	// 	scopedSlots: {customRender: 'loan'}
	// },
	{
		dataIndex: 'updated_at',
		key: 'updatedAt',
		title: 'Last Updated',
		scopedSlots: {customRender: 'updatedAt'}
	}, {
		key: 'state',
		title: "State",
		width: 100,
		align: 'center',
		scopedSlots: {customRender: 'state'}
	}, {
		key: 'action',
		title: '',
		width: 150,
		align: 'right',
		scopedSlots: {customRender: 'action'}
	}
]
